import React, { memo } from 'react'

type BoxType = {
  children: React.ReactNode
  patent?: boolean
  thumnail?: boolean
  boxsize?:
    | 'column_w280'
    | 'sec_inner_w293'
    | 'sec_inner_w620'
    | 'column_w450'
    | 'sec_detail'
  bgcolor?:
    | 'primary'
    | 'darken'
    | 'textblack'
    | 'white'
    | 'secondary'
    | 'darkgray'
  boxstyle?: 'big_thumnail' | 'simple'
  customstyle?: string
}

export const Box: React.FC<BoxType> = memo(
  ({
    children,
    patent = false,
    thumnail = false,
    boxsize,
    bgcolor = '[transparent]',
    boxstyle = 'simple',
    customstyle
  }) => {
    return (
      <div
        className={`${boxstyle} box relative bg-${bgcolor} ${boxsize} ${customstyle} ${
          boxsize === 'sec_inner_w293'
            ? 'relative lg:py-10 px-8 border rounded-lg border-solid border-gray lg:w-sm w-full py-6'
            : boxsize
        }${
          thumnail
            ? 'border-gray py-6 px-6 lg:py-10 lg:px-[1.9rem] border rounded-lg border-solid'
            : ''
        } max-w-full`}
      >
        {patent && (
          <img
            src="/images/img_icon_patent.png"
            className="absolute top-[-0.5rem] left-[-0.5rem] w-[82px] h-[80px]"
            alt="特許技術"
          />
        )}
        {children}
      </div>
    )
  }
)

Box.displayName = 'Box'
